(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["merah-home-04"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.documentElement;
  if (root.dataset.scentInteractionBound) return;
  root.dataset.scentInteractionBound = "true";
  const reduced = matchMedia("(prefers-reduced-motion: reduce)");
  const fine = matchMedia("(hover: hover) and (pointer: fine)");
  let frame = 0;
  document.addEventListener("pointermove", event => {
    if (!fine.matches || reduced.matches || event.pointerType === "touch") return;
    const card = event.target.closest('#scents[data-scent-interaction="true"] .home-scent');
    if (!card || card.closest('[data-merchant-motion="false"],[data-merchant-hover="false"]')) return;
    const x = event.clientX, y = event.clientY;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const image = card.querySelector(".scent-card-image");
      if (!image) return;
      const bounds = image.getBoundingClientRect();
      const px = Math.max(15, Math.min(85, (x-bounds.left)/bounds.width*100));
      const py = Math.max(20, Math.min(80, (y-bounds.top)/bounds.height*100));
      image.style.setProperty("--scent-x", px.toFixed(1)+"%");
      image.style.setProperty("--scent-y", py.toFixed(1)+"%");
    });
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();
})();
